import { Path } from 'adminConsole'
import { AddButton, ReloadButton } from 'adminConsole/component'
import { CodeMapCategory, SelectCodeMapField } from 'adminConsole/page'
import { codeMapStore } from 'adminConsole/store'
import { Field, Form, Formik } from 'formik'
import { Loading } from 'mobileApp/common/page'
import { useEffect, useState } from 'react'
import { useHistory } from 'react-router'

export const QueryList = () => {
  const [isLoading, setIsLoading] = useState(true)
  const history = useHistory()
  const codeMapList = codeMapStore.codeMapList

  const getCodeMapList = () => {
    setIsLoading(true)
    codeMapStore.getCodeMapList().finally(() => setIsLoading(false))
  }

  useEffect(() => getCodeMapList(), [])

  const handleReloadClick = () => getCodeMapList()
  const handleCodeMapClick = (id: number) => history.push(`${Path.CodeMap}/${id}`)

  if (isLoading) return <Loading />

  return (
    <Formik initialValues={{ category: '' }} onSubmit={() => {}}>
      {({ values }) => {
        const filteredList = values.category
          ? codeMapList.filter(item => item.category === values.category)
          : codeMapList

        return (
          <main>
            <Form>
              {' '}
              <section className="form-row mb-4 flex justify-content-between">
                <div className="col-4">
                  <Field
                    name="category"
                    placeholder="請選擇類型"
                    category={CodeMapCategory.ListCodeMapCategory}
                    codeMapList={codeMapList}
                    component={SelectCodeMapField}
                  />
                </div>

                <div className="col-2 d-flex flex-row-reverse align-items-center">
                  <ReloadButton disabled={isLoading} onClick={handleReloadClick} />
                  <AddButton to={`${Path.CodeMap}/0`} className="mr-3" />
                </div>
              </section>
            </Form>

            <section>
              <table className="table table-hover">
                <thead>
                  <tr>
                    <th>類型</th>
                    <th>順序</th>
                    <th>描述</th>
                    <th>值</th>
                    <th>狀態</th>
                    <th>保留1</th>
                    <th>保留2</th>
                  </tr>
                </thead>

                <tbody>
                  {filteredList.map(item => (
                    <tr key={item.id} onClick={() => handleCodeMapClick(item.id)} style={{ cursor: 'pointer' }}>
                      <td>{item.category}</td>
                      <td>{item.precedence}</td>
                      <td>{item.name}</td>
                      <td>{item.value}</td>
                      <td>{item.enable ? '啟用' : '停用'}</td>
                      <td>{item.reserve1}</td>
                      <td>{item.reserve2}</td>
                    </tr>
                  ))}
                  {filteredList.length === 0 && (
                    <tr>
                      <td colSpan={7} className="text-center text-muted py-4">
                        查無資料
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </section>
          </main>
        )
      }}
    </Formik>
  )
}
